import { c as _c } from "react/compiler-runtime";
import { AddIcon } from '@systemeio/ui/icons';
import { PrimaryButton } from '@systemeio/ui';
import { Dispatch, SetStateAction, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface AddLectureButtonProps {
  onClick: (setFetching: Dispatch<SetStateAction<boolean>>) => void;
}
export const AddLectureButton = t0 => {
  const $ = _c(11);
  const {
    onClick
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [fetching, setFetching] = useState(false);
  let t1;
  if ($[0] !== onClick) {
    t1 = () => {
      onClick(setFetching);
    };
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <AddIcon />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("dashboard.course.add_lecture_modal.trigger_title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span>{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== fetching || $[8] !== t1 || $[9] !== t4) {
    t5 = <PrimaryButton onClick={t1} isFetching={fetching} data-test="module-create-lecture">{t2}{t4}</PrimaryButton>;
    $[7] = fetching;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};